module.exports = __webpack_public_path__ + "img/5.f5aeed62.png";